/* REDUX */
import { connect } from "react-redux"

/* SAGA ACTIONS */
import { logoutAction } from "components/login/actions"

/* THE COMPONENT */
import LogoutLink from "./component" 

export default connect(null, { logoutAction })(LogoutLink)